import {
  FetchAppointmentNotification,
  FetchAppointmentNotificationVariables,
} from 'types/graphql'

import { TypedDocumentNode, useQuery } from '@cedarjs/web'

const QUERY: TypedDocumentNode<
  FetchAppointmentNotification,
  FetchAppointmentNotificationVariables
> = gql`
  query FetchAppointmentNotification($id: String!) {
    appointmentConfirmation(id: $id) {
      id
      appointmentId
      status
      start
      tenantId
      logoUrl
      tenantSettings {
        id
        minimumMinorAge
        allowSelfCheckInInsuranceAgeThresholdInDays
        allowPatientInsuranceUpdateDuringCheckIn
      }
      patientRegistrationIntentId
      patientName
      patientDateOfBirth
      patientCheckInCompletedAt
      canCheckIn
      canConfirmOrReschedule
      locationName
      locationAddress
      locationPhoneNumber
      practiceName
      practiceWebsiteUrl
      confirmedAt
      appointmentTypes
      practitionerName
      patientId
      featureToggles
      requiresInsuranceReviewTask
      usesInsuranceReviewAgent
      notificationSentTo {
        patientId
        patientLegalStatus
        relatedPersonId
        name
        relationshipToPatient
        guardianshipType
      }
      requiredPracticeForms {
        id
        formSchemas
        richTextContent
        practiceFormDefinition {
          id
          classificationSubType
        }
        binary {
          content {
            url
            contentType
          }
        }
      }
    }
  }
`

export const useAppointmentConfirmation = ({
  notificationId,
  skip,
}: {
  notificationId: string
  skip?: boolean
}) =>
  useQuery<FetchAppointmentNotification, FetchAppointmentNotificationVariables>(
    QUERY,
    {
      variables: { id: notificationId },
      skip,
    }
  )
